import React, { useState } from 'react';

interface AuthFormProps {
  onSubmit: (username: string, password: string) => Promise<any>;
  error?: string | null;
}

function AuthForm({ onSubmit, error }: AuthFormProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    setSubmitting(true);
    try {
      await onSubmit(username, password);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fase-monitor fase-monitor--auth">
      <div className="fase-monitor__auth-overlay">
        <div className="fase-monitor__auth-card">
          <div className="fase-monitor__auth-logo-wrapper">
            <img src="/static/images/airfi-grey-logo.png" alt="AirFi" className="fase-monitor__auth-logo" />
          </div>
          <h1 className="fase-monitor__auth-title">FASE Fleet Monitor</h1>
          <p className="fase-monitor__auth-subtitle">Enter your credentials to continue</p>
          <form onSubmit={handleSubmit} className="fase-monitor__auth-form">
            <div className="fase-monitor__auth-field">
              <label className="fase-monitor__auth-label" htmlFor="fase-username">
                Username
              </label>
              <input
                id="fase-username"
                className="fase-monitor__auth-input"
                type="text"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={submitting}
              />
            </div>
            <div className="fase-monitor__auth-field">
              <label className="fase-monitor__auth-label" htmlFor="fase-password">
                Password
              </label>
              <input
                id="fase-password"
                className="fase-monitor__auth-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={submitting}
              />
            </div>
            {error && <p className="fase-monitor__auth-error">{error}</p>}
            <button className="fase-monitor__auth-submit" type="submit" disabled={submitting || !username || !password}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AuthForm;
